export function register(onUpdate) {
  // Solo registrar en producción y si el navegador soporta Service Workers
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

      navigator.serviceWorker.register(swUrl)
        .then((registration) => {
          //console.log('[PWA] Service Worker registrado con éxito. Scope:', registration.scope);

          // Si el SW ya está listo y esperando activación (actualización en caliente)
          if (registration.waiting) {
            if (onUpdate) onUpdate(registration);
          }

          // Si se detecta un nuevo SW descargándose/instalándose
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  //console.log('[PWA] Nueva versión precacheada y lista para usarse.');
                  if (onUpdate) onUpdate(registration);
                } else {
                  //console.log('[PWA] Recursos cacheados para uso offline.');
                }
              }
            };
          };
        })
        .catch((error) => {
          // MODO DEGRADADO: El fallo del registro del SW no bloquea el funcionamiento del cliente
          //console.error('[PWA] Error al registrar el Service Worker (Modo degradado activo):', error);
        });
    });
  } else {
    // MODO DEGRADADO: Entornos de desarrollo o navegadores sin soporte
    //console.log('[PWA] Entorno de desarrollo o sin soporte de Service Workers. Modo degradado activo.');
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
